import { render } from "./OutgoingParcel.vue?vue&type=template&id=bed0654c"
import script from "./OutgoingParcel.vue?vue&type=script&lang=js"
export * from "./OutgoingParcel.vue?vue&type=script&lang=js"

import "./OutgoingParcel.vue?vue&type=style&index=0&id=bed0654c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__